<template>
  <div class="imei-manual-tab">
    <div class="d-flex flex-wrap align-items-center mb-2 imei-manual-tab__add-row">
      <b-input
        :value="newImeiInput"
        size="sm"
        class="imei-manual-tab__add-input flex-grow-1"
        placeholder="Nhập mã IMEI mới rồi Enter..."
        autocomplete="off"
        @input="$emit('update:newImeiInput', $event)"
        @keyup.enter="$emit('add')"
      />
      <b-button variant="danger" size="sm" class="imei-manual-tab__add-btn" @click="$emit('add')">
        <i class="fas fa-plus"></i>
        <strong>Thêm IMEI</strong>
      </b-button>
    </div>

    <div class="d-flex flex-wrap align-items-center mb-2 imei-manual-tab__filter-row">
      <div class="imei-manual-tab__search flex-grow-1">
        <b-input-group size="sm">
          <b-input-group-prepend is-text>
            <i class="fas fa-search text-muted"></i>
          </b-input-group-prepend>
          <b-input
            :value="searchTerm"
            placeholder="Tìm trong danh sách đã nhập..."
            autocomplete="off"
            @input="$emit('update:searchTerm', $event)"
          />
        </b-input-group>
      </div>
      <ImeiInputModalToolbar
        :export-disabled="exportDisabled"
        @template="$emit('template')"
        @import="$emit('import')"
        @export="$emit('export')"
      />
    </div>

    <div class="imei-modal-stats mb-2">
      <span class="badge badge-light imei-modal-stats__badge">Tổng đã nhập: {{ totalCount }}</span>
      <span class="badge badge-light imei-modal-stats__badge">Kết quả lọc: {{ filteredCount }}</span>
    </div>

    <b-table
      :items="displayItems"
      :fields="tableFields"
      :per-page="perPage"
      :current-page="currentPage"
      bordered
      hover
      small
      class="imei-modal-table mb-2"
    >
      <template #cell(actions)="row">
        <div class="d-flex justify-content-center">
          <span
            class="imei-manual-tab__delete"
            @click="$emit('remove', row.item.imeiCode)"
          >
            <i class="flaticon2-rubbish-bin-delete-button"></i>
          </span>
        </div>
      </template>
    </b-table>

    <b-pagination
      v-show="filteredCount > perPage"
      :value="currentPage"
      :total-rows="filteredCount"
      :per-page="perPage"
      align="right"
      size="sm"
      class="mb-0"
      @input="$emit('update:currentPage', $event)"
    />
  </div>
</template>

<script>
  import ImeiInputModalToolbar from './ImeiInputModalToolbar.vue'
  import { buildSttRows } from './imeiInputForm.logic'

  export default {
    name: 'ImeiInputManualTab',
    components: { ImeiInputModalToolbar },
    props: {
      items: { type: Array, default: () => [] },
      newImeiInput: { type: String, default: '' },
      searchTerm: { type: String, default: '' },
      currentPage: { type: Number, default: 1 },
      perPage: { type: Number, default: 50 },
      totalCount: { type: Number, default: 0 },
      filteredCount: { type: Number, default: 0 },
      exportDisabled: { type: Boolean, default: false },
    },
    computed: {
      tableFields() {
        return [
          {
            key: 'stt',
            label: 'STT',
            thStyle: { width: '56px', fontWeight: 600, color: '#181c32' },
            tdClass: 'text-center',
          },
          {
            key: 'imeiCode',
            label: 'IMEI',
            thStyle: { fontWeight: 600, color: '#181c32' },
          },
          {
            key: 'actions',
            label: 'Xoá',
            thStyle: { width: '72px', fontWeight: 600, color: '#181c32' },
            tdClass: 'text-center',
          },
        ]
      },
      displayItems() {
        return buildSttRows(this.items)
      },
    },
  }
</script>

<style scoped>
  .imei-manual-tab__add-row,
  .imei-manual-tab__filter-row {
    gap: 10px 12px;
  }
  .imei-manual-tab__add-input {
    min-width: 200px;
  }
  .imei-manual-tab__add-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    font-weight: 600;
  }
  .imei-manual-tab__search {
    min-width: 200px;
  }
  .imei-manual-tab__delete {
    cursor: pointer;
    font-size: 12px;
  }
  .imei-manual-tab__delete i {
    font-size: 1rem;
    color: #d33;
  }
  .imei-modal-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .imei-modal-stats__badge {
    font-size: 12px;
    font-weight: 500;
    color: #3f4254;
    padding: 6px 10px;
  }
</style>
